import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OrderType } from "../types/OrderType";
import { apiClient } from "src/utils/Api/apiClient";

interface orderState {
        order: OrderType;
        orderLoading: boolean;
        orderError: string | null;
}

const initialState: orderState = {
        order: {
                Id: 0,
                OrderId: "",
                DealerName: "",
                EndUserName: "",
                EndUserInstanceName: "",
                EndUserInstanceLocationName: "",
                DealerId: 0,
                EndUserId: 0,
                EndUserInstanceId: 0,
                EndUserInstanceLocationId: 0,
                UserId: 0,
                NumberOfDoors: 0,
                SalesOrderNumber: 0,
                OrderDate: "",
        },
        orderLoading: true,
        orderError: null
}

export const createOrder = createAsyncThunk(
        'order/createOrder',
        async (orderData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('order/createOrder', orderData);
                        return response.data;
                } catch (orderError: any) {
                        return rejectWithValue(orderError.message || 'An error occured');
                }
        }
);

export const updateOrder = createAsyncThunk(
        'order/updateOrder',
        async (orderData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('order/updateOrder', orderData).then();
                        return response.data;
                } catch (orderError: any) {
                        return rejectWithValue(orderError.message || 'An error occured');
                }
        }
);

export const getOrderById = createAsyncThunk(
        'order/getOrderById',
        async (orderData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`order/getOrderByID/${orderData}`);
                        return response.data;
                } catch (orderError: any) {
                        return rejectWithValue(orderError.message || 'An error occured');
                }
        }
);

const orderSlice = createSlice({
        name: 'order',
        initialState,
        reducers: {
                orderReset: () => initialState,
        },
        extraReducers: (builder) => {
                //add endUsers to server
                builder.addCase(createOrder.pending, (state) => {
                        state.orderLoading = true;
                        state.orderError = null;
                });
                builder.addCase(createOrder.fulfilled, (state, action) => {
                        state.orderLoading = false;
                        state.order = action.payload;
                });
                builder.addCase(createOrder.rejected, (state, action) => {
                        state.orderLoading = false;
                        state.orderError = action.payload as string;
                });
                //update endUsers to server
                builder.addCase(updateOrder.pending, (state) => {
                        state.orderLoading = true;
                        state.orderError = null;
                });
                builder.addCase(updateOrder.fulfilled, (state, action) => {
                        state.orderLoading = false;
                        state.order = action.payload;
                });
                builder.addCase(updateOrder.rejected, (state, action) => {
                        state.orderLoading = false;
                        state.orderError = action.payload as string;
                });
                //get endUsers by ID from server
                builder.addCase(getOrderById.pending, (state) => {
                        state.orderLoading = true;
                        state.orderError = null;
                });
                builder.addCase(getOrderById.fulfilled, (state, action) => {
                        state.orderLoading = false;
                        state.order = action.payload;
                });
                builder.addCase(getOrderById.rejected, (state, action) => {
                        state.orderLoading = false;
                        state.orderError = action.payload as string;
                });
        }
});

export const { orderReset } = orderSlice.actions;
export default orderSlice.reducer;
